<template>
  <a-card :bordered="false">
    <a-button type="primary" @click="showAddModal">添加客服</a-button>
    <custom-page-table
      style="margin-top:20px;"
      ref="tableList"
      :columns="getColumns()"
      :requestPromise="getProListPromise"
    >
      <span slot="avatar" slot-scope="rowItem">
        <img style="width:50px;height:50px" :src="rowItem.record.avatar" alt="">
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editSetting(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="是否确定删除?"
          ok-text="是"
          cancel-text="否"
          @confirm="deleteData(rowItem.record)"
        >
          <a href="#">删除</a>
        </a-popconfirm>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.status ==1">使用中</a>
        <a v-else @click="showHint(rowItem.record)">启用客服</a>
        <a-divider type="vertical"/>
        <a @click="showReceptionModal(rowItem.record)">接待人员管理</a>
      </span>
    </custom-page-table>
    <a-modal
      centered
      :title="ruleForm.openKfId?'编辑客服':'添加客服'"
      :visible="addVisible"
      @cancel="closeAddModal"
      @ok="submitEvent"
      :confirmLoading="confirmLoading"
      :width=600
    >
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="formLayout.labelCol"
        :wrapper-col="formLayout.wrapperCol">
        <a-form-model-item label="名称" prop="name">
          <a-input style="width:200px;" v-model="ruleForm.name" :maxLength="8" placeholder="请输入客服名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="头像" prop="urlPath">
          <a-upload
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="handleChange"
            :before-upload="beforeUploadFile"
          >
            <img v-if="ruleForm.urlPath" :src="ruleForm.urlPath" alt="avatar" class="selected-image"/>
            <a v-else>
              上传头像
            </a>
          </a-upload>
          <span>温馨提示：图片建议上传大小 2M以内，格式.jpg、.png</span>
        </a-form-model-item>
        <div v-if="ruleForm.openKfId">
          <a-form-model-item label="帐号id">
            {{ ruleForm.openKfId }}
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal
      centered
      title="启用客服"
      :visible="hintVisible"
      @cancel="closeHint"
      @ok="openSetting"
      :width=600
    >
      <div class="title">确认启用当前客服？</div>
      <div class="text">温馨提示：系统只充许启动一个在线客服，启用当前客服时，已设置客服，将被停用</div>
    </a-modal>
    <a-modal
      centered
      title="选择成员"
      :visible="receptionVisible"
      @cancel="closeReception"
      @ok="chooseReception"
      :width=1000
      class="reception-modal"
    >
      <div class="reception-box">
        <div class="reception-left-box">
          <a-input-search placeholder="请输入成员名称" v-model="searchWord" enter-button @search="onSearchReception"/>
          <div class="reception-list">
            <div class="reception-item" v-for="(item,index) in receptionList" :key="index" @click="selectedItem(item)">
              <div>
                <a-icon type="user" style="margin-right: 4px;"/>
                {{ item.name }}
              </div>
              <a-icon v-if="item.isSelected" type="check"/>
            </div>
          </div>
        </div>
        <div class="reception-right-box">
          <div class="reception-title">已选择的员工</div>
          <div class="selected-list">
            <a-tag style="margin-bottom:8px;" v-for="item in selectedList" :key="item.id" closable
                   @close="()=>deleteSelectedItem(item)">
              {{ item.name }}
            </a-tag>
          </div>
        </div>
      </div>
    </a-modal>
    <SettingComponent :visible="settingVisible" @change="changeEvent" @submit="submitSetting"></SettingComponent>
  </a-card>
</template>

<script>
import SettingComponent from '@/views/service/serviceProvider/online/SettingComponent'
import formMixin from '@/utils/mixins/formMixins'

export default {
  name: 'WechatManagement',
  components: {
    SettingComponent
  },
  mixins: [formMixin],
  data() {
    return {
      formLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 19
        }
      },
      settingVisible: false,
      record: {},
      hintVisible: false,
      addVisible: false,
      ruleForm: {
        name: '',
        urlPath: ''
      },
      rules: {
        name: [{ required: true, message: '请输入客服名称', trigger: 'blur' }],
        urlPath: [{ required: true, message: '请上传头像', trigger: 'blur' }]
      },
      loading: false,
      confirmLoading: false,
      receptionVisible: false,
      receptionList: [],
      allReceptionList: [],
      selectedList: [],
      searchWord: ''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    closeHint() {
      this.hintVisible = false
    },
    showHint(record) {
      this.getWxCustomerUserList(record.openKfId)
        .then(res => {
          if (res && res.bindUsers && res.bindUsers.length) {
            this.record = record
            this.hintVisible = true
          } else {
            this.$message.error('未添加接待人员，不能启用该客服')
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.confirmLoading = false)
    },
    getWxCustomerUserList(openKfId) {
      return new Promise((resolve, reject) => {
        let params = {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          openKfId: openKfId
        }
        this.getHttpServices().getServerApiService().post('wxCustomer/getWxCustomerUserList', params)
          .then(res => {
            resolve(res)
          })
          .catch(reason => reject(reason))
      })
    },
    getSelectedList() {
      this.getWxCustomerUserList(this.record.openKfId)
        .then(res => {
          this.receptionList = res.unBindUsers.map(item => {
            return {
              id: item,
              name: item,
              isSelected: false
            }
          })
          this.allReceptionList = this.receptionList
          this.selectedList = res.bindUsers.map(item => {
            return {
              id: item,
              name: item,
              isSelected: false
            }
          })
          this.getDealData()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.confirmLoading = false)
    },
    deleteSelectedItem(item) {
      this.selectedList = this.selectedList.filter(tag => tag.id !== item.id)
      this.getDealData()
    },
    getDealData() {
      if (this.receptionList && this.receptionList.length) {
        this.receptionList.forEach(item => {
          if (this.selectedList.some(i => i.id == item.id)) {
            item.isSelected = true
          } else {
            item.isSelected = false
          }
        })
      }
    },
    selectedItem(item) {
      if (this.selectedList && this.selectedList.length) {
        if (!item.isSelected) {
          this.selectedList.push(item)
        }
      } else {
        this.selectedList.push(item)
      }
      this.getDealData()
    },
    chooseReception() {
      if (this.selectedList && this.selectedList.length) {
        let userIds = this.selectedList.map(item => {
          return item.id
        })
        let params = {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          openKfId: this.record.openKfId,
          userIds: userIds
        }
        this.getHttpServices().getServerApiService().post('wxCustomer/bindWxCustomerUser', params)
          .then(res => {
            this.$message.success('成功添加')
            this.receptionVisible = false
          }).catch(reason => this.showNetWorkErrorMessage(reason))
          .finally(() => this.confirmLoading = false)
      } else {
        this.$message.error('最少需要添加一个接待人员')
      }
    },
    onSearchReception() {
      if (this.searchWord) {
        if (this.allReceptionList && this.allReceptionList.length) {
          let list = []
          this.allReceptionList.forEach(item => {
            if (item.id.indexOf(this.searchWord) != -1) {
              list.push(item)
            }
          })
          this.receptionList = list
        }
      } else {
        this.receptionList = this.allReceptionList
      }

    },
    showReceptionModal(record) {
      this.record = record
      this.searchWord = ''
      this.receptionList = []
      this.allReceptionList = []
      this.selectedList = []
      this.getSelectedList()
      this.receptionVisible = true
    },
    closeReception() {
      this.receptionVisible = false
    },
    getProListPromise(params) {
      params.platformId = this.getPlatformConfig().platformId
      params.merchantId = this.$store.getters.userInfo.merchantId
      return this.getHttpServices().getServerApiService().post('wxCustomer/getList', params)
    },
    submitSetting(value) {
      if (value == 1) {
        this.openNewPage('QuestionTemplate', {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        })
      }
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.urlPath = url
        this.loading = false
      }
    },
    showAddModal() {
      this.ruleForm = {
        name: '',
        urlPath: '',
        openKfId: ''
      }
      this.addVisible = true
    },
    closeAddModal() {
      this.addVisible = false
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.confirmLoading = true
      let params = {
        platformId: this.getPlatformConfig().platformId,
        merchantId: this.$store.getters.userInfo.merchantId,
        name: this.ruleForm.name,
        urlPath: this.ruleForm.urlPath
      }
      let url = 'wxCustomer/add'
      if (this.ruleForm.openKfId) {
        params.openKfId = this.ruleForm.openKfId
        url = 'wxCustomer/update'
      }
      this.getHttpServices().getServerApiService().post(url, params)
        .then(res => {
          this.addVisible = false
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.confirmLoading = false)
    },
    changeEvent(e) {
      this.settingVisible = e
    },
    deleteData(record) {
      let params = {
        platformId: this.getPlatformConfig().platformId,
        merchantId: this.$store.getters.userInfo.merchantId,
        openKfId: record.openKfId
      }
      this.getHttpServices().getServerApiService().post('wxCustomer/del', params)
        .then(res => {
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    openSetting() {
      let params = {
        platformId: this.getPlatformConfig().platformId,
        merchantId: this.$store.getters.userInfo.merchantId,
        openKfId: this.record.openKfId
      }
      this.getHttpServices().getServerApiService().post('wxCustomer/enable', params)
        .then(res => {
          this.hintVisible = false
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    editSetting(record) {
      this.ruleForm = {
        name: record.kfName,
        urlPath: record.avatar,
        openKfId: record.openKfId
      }
      this.addVisible = true
    },
    getColumns() {
      return [
        {
          title: '客服账号ID',
          dataIndex: 'openKfId'
        },
        {
          title: '客服头像',
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '客服账号名称',
          dataIndex: 'kfName'
        },
        {
          title: '客服账号链接',
          dataIndex: 'url'
        },
        {
          title: '设置',
          dataIndex: 'action',
          width: '280px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.text {
  margin-top: 30px;
  text-align: center;
}

.selected-image {
  width: 100px;
  height: 100px;
}

.reception-modal {
  .reception-box {
    display: flex;
    width: 100%;
    height: 100%;

    .reception-left-box {
      width: 40%;
      padding: 16px 0 16px 16px;
      border-right: 1px solid #e8e8e8;

      .reception-list {
        margin-top: 16px;
        padding-right: 16px;
        max-height: 400px;
        overflow: auto;

        .reception-item {
          padding-left: 10px;
          margin-bottom: 10px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }

    .reception-right-box {
      width: 60%;
      padding: 16px;

      .reception-title {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }
  }
}

</style>
<style lang="less">
.reception-modal {
  .ant-modal-body {
    padding: 0 !important;
  }
}
</style>